import React, { useEffect } from 'react';
import type { QuestionWithSlide } from '@mentimeter/editor-schema/api-types-overrides';
import { WelcomeModal } from '../components/WelcomeModal';
import { useDisableJoinInstructions } from '../hooks/use-disable-join-instructions';
import { trackEditorTourSeen } from '../utils/track-editor-tour';
import { useTourStore } from '../hooks';

const HAS_SEEN_FORCEFUL_EDITOR_TOUR_KEY = 'has-seen-forceful-editor-tour';

export const getOnboardingSeenFromLocalStorage = () => {
  const onboardingSeen = localStorage.getItem(
    HAS_SEEN_FORCEFUL_EDITOR_TOUR_KEY,
  );
  return onboardingSeen === 'true';
};

export const setOnboardingSeenInLocalStorage = () => {
  localStorage.setItem(HAS_SEEN_FORCEFUL_EDITOR_TOUR_KEY, 'true');
};

export const EditorTourDataHandler = ({
  seriesId,
  activeQuestion,
}: {
  seriesId: string;
  activeQuestion: QuestionWithSlide;
}) => {
  const hasSeenForcefulEditorTour = getOnboardingSeenFromLocalStorage();
  const { progressTour, isActive } = useTourStore();

  useDisableJoinInstructions(seriesId, activeQuestion);

  useEffect(() => {
    if (!hasSeenForcefulEditorTour) {
      trackEditorTourSeen();
    }
  }, [hasSeenForcefulEditorTour]);

  if (hasSeenForcefulEditorTour) {
    return null;
  }

  const handleClick = () => {
    progressTour();
  };

  return (
    <WelcomeModal
      open={!hasSeenForcefulEditorTour && !isActive}
      handleClick={handleClick}
    />
  );
};
